namespace Areas.Project.List {
    "use strict";

    export function onGridSelectionChanged(e: any) {
        const rowSelected = e.selectedRowsData.length === 1;

        if (rowSelected) {
            enableButton("EditButton");
        } else {
            disableButton("EditButton");
        }
    }

    export function view() {
        gotoSelected("ProjectsGrid", "/Project/Profile/View/");
    }

    export function edit() {
        gotoSelected("ProjectsGrid", "/Project/Profile/Edit/");
    }

    export function showCreate() {
        $("#CreateProjectPopup").dxPopup("instance").show();
    }

    export function insertRecord(e: any) {
        const form = $("#CreateProjectForm").dxForm("instance");
        const result: any = form.validate();

        if (result.isValid) {
            const newData: any = form.option("formData");

            sendRequest("/Project/List/Post", JSON.stringify(newData), "POST");
        }
    }

    export function columnViewLink(cellElement: any, cellInfo: any) {
        let linkInfo = "<a href= '/Project/Profile/View/{placeholder}'>View</a>";

        buildCellContent(cellElement,
            () => { return cellInfo.data.projectId; },
            linkInfo);
    }
}